<template>
    <div>
        <!-- 关联发布 -->
        <el-table :data="detail.toDeploy">
            <el-table-column label="编号" prop="serialNumber"></el-table-column>
            <el-table-column label="标题" prop="title">
                <template slot-scope="scope">
                    <el-button type="text" @click="toCorrectDetail(scope.row.serialNumber)">{{scope.row.title}}</el-button>
                </template>
            </el-table-column>

            <el-table-column label="发布分类" prop="category">
                <template slot-scope="scope">
                    {{ scope.row.category | tableVal(deployList,'t') }}
                </template>
            </el-table-column>
            <el-table-column label="报告人" prop="requester"></el-table-column>
            <el-table-column label="指派人" prop="designator"></el-table-column>
            <el-table-column label="创建时间" prop="createTime"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props:{
            detail:Object,
            deployList:Array
        },
        data() {
            return {

            }
        },
        created() {
            // console.log(1);

        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },

            deployCategory(){
                return this.dictionary.deploy_category;
            },
        },
        methods: {
            //点击待办或请求中列表名称时跳转对应详情
            toCorrectDetail(val){
                this.$router.push({path:'/deployDetail',query:{serialNumber:val}})
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
